import abstractModel from "../../core/ShopModel";

const resource = 'retailers/orders';

const model = abstractModel(resource);

model.sendToContifico = (id) => {
  const newResource = `retailers/orders/${id}/send_to_contifico`;
  return model.post({}, { path: newResource });
};
export default model;
